import axios from '@fs/zion-axios'
import { dataURItoBlob } from '../helpers/image_helper'

const aamServiceBase = '/service/discovery/allaboutme'
const waifServiceBase = '/service/discovery/wicf'
const commonServiceBase = '/service/discovery/common'

export const getDetailedFamilyTreeData = async (generations = 8, includeLocations = false) => {
  return axios.get(`${waifServiceBase}/family?generations=${generations}&includeLocations=${includeLocations}`)
}

export const getFamilyTreeData = async (generations = 8, { includeLocations = false } = {}) => {
  if (includeLocations) return getDetailedFamilyTreeData(generations, true)
  return axios.get(`${aamServiceBase}/getFamily?generations=${generations}&includeLocations=false`)
}

export const getFamilyTreeDetails = async (generations = 8, includeLocations = false) => {
  return axios.get(`/service/discovery/wicf/family?generations=${generations}&includeLocations=${includeLocations}`)
}

export const getCampaigns = async (cisId) => {
  // This cisId is needed for cache-busting in helper mode, but cannot use the `cisId` param name
  return axios.get('/service/campaign/sna/api/summary/userSummary', { params: { c: cisId } })
}

export const getMemories = async ({ personId }) => {
  return personId ? axios.get(`${commonServiceBase}/memory/person/${personId}?count=100`) : null
}

export const getTreeData = async ({ personId }) => {
  return personId ? axios.get(`/platform/tree/persons/${personId}`) : null
}

export const getPersonAboutData = async ({ personId }) => {
  return personId ? axios.get(`/service/tree/tree-data/v8/person/${personId}/about`) : null
}

export const createLongPollSession = async () => axios.post(`/service/discovery/common/poll/session`)

export const deleteLongPollSession = async ({ longPollSessionId }) => {
  return longPollSessionId ? axios.delete(`/service/discovery/common/poll/session/${longPollSessionId}`) : null
}

export const getLongPollData = async ({ longPollSessionId }) => {
  return longPollSessionId ? axios.get(`/service/discovery/common/poll/session/${longPollSessionId}/profile`) : null
}

export const postLongPollData = async ({ longPollSessionId, dataURI }) => {
  if (!longPollSessionId || !dataURI) return null
  const imageBlob = dataURItoBlob(dataURI)
  const fd = new FormData()
  fd.append('image', imageBlob, `${longPollSessionId}.jpg`)
  return axios.post(`/service/discovery/common/poll/session/${longPollSessionId}/profile/add`, fd)
}
